var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ModalFullScreen", {
    attrs: { size: "xl" },
    on: { close: _vm.closeModal },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("span", { staticClass: "font-semibold text-base" }, [
              _vm._v("Add info to resource"),
            ]),
            _c(
              "span",
              {
                staticClass:
                  "cursor-pointer flex items-center justify-center absolute top-4 right-7",
                on: {
                  click: _vm.closeModal,
                  mouseover: function ($event) {
                    _vm.isHovered = true
                  },
                  mouseout: function ($event) {
                    _vm.isHovered = false
                  },
                },
              },
              [
                !_vm.isHovered
                  ? _c("CrossIcon", { staticClass: "h-3.5 w-3.5" })
                  : _vm._e(),
                _vm.isHovered
                  ? _c("CrossIconHover", { staticClass: "close-icon" })
                  : _vm._e(),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "content",
        fn: function () {
          return [
            _c(
              "ModalContent",
              { staticClass: "relative" },
              [
                _c(
                  "LoadingOverlay",
                  { attrs: { loading: _vm.loading, hasData: true } },
                  [
                    _vm.managementAddedInfoMode.skills
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "Background",
                                  body: "Add skills to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c(
                                  "FormGroup",
                                  {
                                    attrs: {
                                      title: "Skills (50 Max)",
                                      inputClass: "fullwidthInput",
                                    },
                                  },
                                  [
                                    _c("CustomSkillsMultiselectNew", {
                                      key: _vm.skillsComponentKey,
                                      attrs: {
                                        previouslyChosenSkillsIds:
                                          _vm.skillsIds,
                                        max: 50,
                                        companyId: _vm.companyId,
                                        customSkillLabel:
                                          "Select or type to add new skill",
                                        newSkillLabel: "Add new skill",
                                        getParentContainer: "fullWidthInput",
                                      },
                                      on: {
                                        skillsListUpdated:
                                          _vm.handleSkillsListUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled: !_vm.skillsIds.length,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertSkills()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.softSkills
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "Background",
                                  body: "Add soft skills to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c(
                                  "FormGroup",
                                  {
                                    attrs: {
                                      title: "Soft Skills (50 Max)",
                                      inputClass: "fullwidthInput",
                                    },
                                  },
                                  [
                                    _c("CustomSoftSkillsMultiselectNew", {
                                      key: _vm.softSkillsComponentKey,
                                      attrs: {
                                        previouslyChosenSoftSkillsIds:
                                          _vm.softSkillsIds,
                                        max: 50,
                                        companyId: _vm.companyId,
                                        customSoftSkillLabel:
                                          "Select or type to add new soft skill",
                                        newSoftSkillLabel: "Add new soft skill",
                                        getParentContainer: "fullWidthInput",
                                      },
                                      on: {
                                        softSkillsListUpdated:
                                          _vm.handleSoftSkillsListUpdated,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled: !_vm.softSkillsIds.length,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertSoftSkills()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.industries
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                staticClass: "mt-6",
                                attrs: {
                                  title: "Background",
                                  body: "Add industries to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c(
                                  "FormGroup",
                                  {
                                    staticClass: "mt-2",
                                    attrs: { title: "Industries (10 Max)" },
                                  },
                                  [
                                    _c("IndustriesMultiselect", {
                                      attrs: { max: 10 },
                                      model: {
                                        value: _vm.industries,
                                        callback: function ($$v) {
                                          _vm.industries = $$v
                                        },
                                        expression: "industries",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                    attrs: { id: "moreindustriesmsg" },
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled: !_vm.industries.length,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertIndustries()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.languages
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                staticClass: "mt-6",
                                attrs: {
                                  title: "Background",
                                  body: "Add languages to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c(
                                  "FormGroup",
                                  {
                                    staticClass: "mt-2",
                                    attrs: { title: "Languages (5 Max)" },
                                  },
                                  [
                                    _c("LanguagesMultiselect", {
                                      attrs: { max: 5 },
                                      model: {
                                        value: _vm.languages,
                                        callback: function ($$v) {
                                          _vm.languages = $$v
                                        },
                                        expression: "languages",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                    attrs: { id: "morelanguagesmsg" },
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled: !_vm.languages.length,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertLanguages()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.workSamples
                      ? _c(
                          "div",
                          [
                            _c("AddWorkSamplesToContractor", {
                              attrs: {
                                userId: _vm.userId,
                                id: "workSamples",
                                currentUserId: _vm.currentUser.id,
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.experience
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "Experience",
                                  body: "Add experience to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                !_vm.showExperienceForm
                                  ? _c("UIButton", {
                                      staticClass: "flex justify-end mb-4",
                                      attrs: {
                                        icon: "plus",
                                        buttonText: "Add experience",
                                        variant: "black",
                                        id: "experienceslot",
                                      },
                                      on: {
                                        click: () => {
                                          _vm.showExperienceForm = true
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.showExperienceForm
                                  ? _c("ExperienceForm", {
                                      attrs: {
                                        userId: _vm.userId,
                                        currentUserId: _vm.currentUser.id,
                                      },
                                      on: {
                                        added: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                      },
                                      model: {
                                        value: _vm.showExperienceForm,
                                        callback: function ($$v) {
                                          _vm.showExperienceForm = $$v
                                        },
                                        expression: "showExperienceForm",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._l(
                                  _vm.experiencesByManagement,
                                  function (experience) {
                                    return _c("ExperienceCard", {
                                      key: experience.id,
                                      staticClass: "mt-4",
                                      attrs: {
                                        experience: experience,
                                        userId: _vm.userId,
                                        currentUserId: _vm.currentUser.id,
                                      },
                                      on: {
                                        updated: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                        removed: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                      },
                                    })
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.education
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "Education",
                                  body: "Add education records to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                !_vm.showEducationForm
                                  ? _c("UIButton", {
                                      staticClass: "flex justify-end mb-4",
                                      attrs: {
                                        icon: "plus",
                                        id: "educationslot",
                                        buttonText: "Add education",
                                        variant: "black",
                                      },
                                      on: {
                                        click: () => {
                                          _vm.showEducationForm = true
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.showEducationForm
                                  ? _c("EducationForm", {
                                      attrs: {
                                        userId: _vm.userId,
                                        currentUserId: _vm.currentUser.id,
                                      },
                                      on: {
                                        added: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                      },
                                      model: {
                                        value: _vm.showEducationForm,
                                        callback: function ($$v) {
                                          _vm.showEducationForm = $$v
                                        },
                                        expression: "showEducationForm",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._l(
                                  _vm.educationsByManagement,
                                  function (education) {
                                    return _c("EducationCard", {
                                      key: education.id,
                                      staticClass: "mt-4",
                                      attrs: {
                                        education: education,
                                        userId: _vm.userId,
                                        currentUserId: _vm.currentUser.id,
                                      },
                                      on: {
                                        updated: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                        removed: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                      },
                                    })
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.certification
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "Certifications",
                                  body: "Add any certifications to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                !_vm.showCertificationForm
                                  ? _c("UIButton", {
                                      staticClass: "flex justify-end mb-4",
                                      attrs: {
                                        icon: "plus",
                                        id: "certificationslot",
                                        variant: "black",
                                        buttonText: "Add certification",
                                      },
                                      on: {
                                        click: () => {
                                          _vm.showCertificationForm = true
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _vm.showCertificationForm
                                  ? _c("CertificationForm", {
                                      attrs: {
                                        userId: _vm.userId,
                                        currentUserId: _vm.currentUser.id,
                                      },
                                      on: {
                                        added: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                      },
                                      model: {
                                        value: _vm.showCertificationForm,
                                        callback: function ($$v) {
                                          _vm.showCertificationForm = $$v
                                        },
                                        expression: "showCertificationForm",
                                      },
                                    })
                                  : _vm._e(),
                                _vm._l(
                                  _vm.certificationsByManagement,
                                  function (certification) {
                                    return _c("CertificationCard", {
                                      key: certification.id,
                                      staticClass: "mt-4",
                                      attrs: {
                                        certification: certification,
                                        userId: _vm.userId,
                                        currentUserId: _vm.currentUser.id,
                                      },
                                      on: {
                                        updated: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                        removed: () => {
                                          _vm.closeModalAndRefreshContractor()
                                        },
                                      },
                                    })
                                  }
                                ),
                              ],
                              2
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.rating
                      ? _c("div", [_vm._v("Rating")])
                      : _vm._e(),
                    _vm.managementAddedInfoMode.contactInfo
                      ? _c(
                          "div",
                          { attrs: { id: "contactinfoslot" } },
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "About resource",
                                  body: "Provide information about the resource",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "Email Address",
                                    rules: "email",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("FormGroup", {
                                              staticClass: "mt-6",
                                              attrs: {
                                                name: "email",
                                                title: "Email Address",
                                                placeholder: "Enter email",
                                                errors: errors,
                                              },
                                              on: {
                                                hasErrors: (hasErrors) => {
                                                  _vm.emailHasErrors = hasErrors
                                                },
                                              },
                                              model: {
                                                value: _vm.email,
                                                callback: function ($$v) {
                                                  _vm.email = $$v
                                                },
                                                expression: "email",
                                              },
                                            }),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    726899968
                                  ),
                                }),
                                _c("ValidationProvider", {
                                  attrs: {
                                    name: "Phone number",
                                    rules: {
                                      phoneNumberLength: [
                                        _vm.phone
                                          ? _vm.phone.toString().length
                                          : 0,
                                      ],
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "FormGroup",
                                              {
                                                attrs: {
                                                  title: "Phone number",
                                                  errors: _vm.phoneTouched
                                                    ? errors
                                                    : [],
                                                },
                                              },
                                              [
                                                _c("MaskedPhoneInput", {
                                                  attrs: {
                                                    invalid: Boolean(
                                                      _vm.phoneTouched &&
                                                        errors.length
                                                    ),
                                                  },
                                                  on: {
                                                    touched: () => {
                                                      _vm.phoneHasErrors =
                                                        !!errors.length
                                                      _vm.phoneTouched = true
                                                    },
                                                  },
                                                  model: {
                                                    value: _vm.phone,
                                                    callback: function ($$v) {
                                                      _vm.phone = $$v
                                                    },
                                                    expression: "phone",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    3071868850
                                  ),
                                }),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled:
                                          (!_vm.email && !_vm.phone) ||
                                          _vm.emailHasErrors ||
                                          _vm.phoneHasErrors,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertProfileByManagement()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.website
                      ? _c(
                          "div",
                          { attrs: { id: "websiteslot" } },
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "About resource",
                                  body: "Provide information about the resource",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "url" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c("FormGroup", {
                                              staticClass: "mt-6",
                                              attrs: {
                                                name: "website",
                                                title: "Website URL",
                                                placeholder: "URL here",
                                                errors: errors,
                                                isIcon: false,
                                              },
                                              model: {
                                                value: _vm.website,
                                                callback: function ($$v) {
                                                  _vm.website = $$v
                                                },
                                                expression: "website",
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "flex justify-end mt-2 pt-3 gap-2",
                                              },
                                              [
                                                _c("UIButton", {
                                                  attrs: {
                                                    buttonText: "Cancel",
                                                    size: "lg",
                                                    variant: "outline",
                                                    processing: _vm.processing,
                                                  },
                                                  on: { click: _vm.closeModal },
                                                }),
                                                _c("UIButton", {
                                                  attrs: {
                                                    buttonText: "Save",
                                                    size: "lg",
                                                    variant: "black",
                                                    processing: _vm.processing,
                                                    disabled:
                                                      !_vm.website ||
                                                      !!errors.length,
                                                  },
                                                  on: {
                                                    click: () => {
                                                      _vm.upsertProfileByManagement()
                                                    },
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    4027902217
                                  ),
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.company
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "About resource",
                                  body: "Provide information about the resource",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c("ValidationObserver", [
                                  _c(
                                    "form",
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "Company name",
                                          rules: "max:160",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("FormGroup", {
                                                    attrs: {
                                                      title: "Company",
                                                      placeholder:
                                                        "Enter company name",
                                                      errors: errors,
                                                    },
                                                    model: {
                                                      value: _vm.company_name,
                                                      callback: function ($$v) {
                                                        _vm.company_name =
                                                          typeof $$v ===
                                                          "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                      },
                                                      expression:
                                                        "company_name",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "flex justify-end mt-2 pt-3 gap-2",
                                                    },
                                                    [
                                                      _c("UIButton", {
                                                        attrs: {
                                                          buttonText: "Cancel",
                                                          size: "lg",
                                                          variant: "outline",
                                                          processing:
                                                            _vm.processing,
                                                        },
                                                        on: {
                                                          click: _vm.closeModal,
                                                        },
                                                      }),
                                                      _c("UIButton", {
                                                        attrs: {
                                                          buttonText: "Save",
                                                          size: "lg",
                                                          variant: "black",
                                                          processing:
                                                            _vm.processing,
                                                          disabled:
                                                            !_vm.company_name ||
                                                            !!errors.length,
                                                        },
                                                        on: {
                                                          click: () => {
                                                            _vm.upsertProfileByManagement()
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          2768706789
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.jobTitle
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "About resource",
                                  body: "Select job title for the resource",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c(
                                  "FormGroup",
                                  {
                                    attrs: {
                                      title: "Job Title",
                                      inputClass: "fullwidthInput",
                                    },
                                  },
                                  [
                                    _c("JobTitleMultiselect", {
                                      attrs: {
                                        getcontainerStyle: "fullWidthInput",
                                        placeholder: "Select job title",
                                      },
                                      on: {
                                        input: _vm.handleJobTitleSelection,
                                      },
                                      model: {
                                        value: _vm.selectedJobTitle,
                                        callback: function ($$v) {
                                          _vm.selectedJobTitle = $$v
                                        },
                                        expression: "selectedJobTitle",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled:
                                          _vm.selectedJobTitle.length !== 1,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.updateUserJobTitle()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.rate
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                staticClass: "mt-6",
                                attrs: {
                                  title: "About resource",
                                  body: "Add rate to resource profile",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass: "grid grid-cols-2 gap-4 mt-2",
                                  },
                                  [
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "col-span-2",
                                        attrs: { title: "Rate" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "title",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "p",
                                                    { staticClass: "mb-2" },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "required-icon",
                                                        },
                                                        [_vm._v("*")]
                                                      ),
                                                      _vm._v("Rate"),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          false,
                                          1009010834
                                        ),
                                      },
                                      [
                                        _c("InputRangeFilter", {
                                          attrs: {
                                            minValue: _vm.min_rate,
                                            maxValue: _vm.max_rate,
                                            inputClasses: "pl-8",
                                            prefix: "$",
                                            iconStyle: "customIcon",
                                            inputClass: "customFormInput",
                                          },
                                          on: {
                                            "update:minValue": function (
                                              $event
                                            ) {
                                              _vm.min_rate = $event
                                            },
                                            "update:min-value": function (
                                              $event
                                            ) {
                                              _vm.min_rate = $event
                                            },
                                            "update:maxValue": function (
                                              $event
                                            ) {
                                              _vm.max_rate = $event
                                            },
                                            "update:max-value": function (
                                              $event
                                            ) {
                                              _vm.max_rate = $event
                                            },
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "row-span-1",
                                        attrs: { title: "Currency" },
                                      },
                                      [
                                        _c("CurrencySelect", {
                                          attrs: {
                                            getcontainerStyle: "fullWidthInput",
                                          },
                                          model: {
                                            value: _vm.currency,
                                            callback: function ($$v) {
                                              _vm.currency = $$v
                                            },
                                            expression: "currency",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "FormGroup",
                                      {
                                        staticClass: "col-span-1",
                                        attrs: { title: "Unit" },
                                      },
                                      [
                                        _c("RateUnitSelect", {
                                          attrs: {
                                            getcontainerStyle: "fullWidthInput",
                                          },
                                          model: {
                                            value: _vm.rate_unit,
                                            callback: function ($$v) {
                                              _vm.rate_unit = $$v
                                            },
                                            expression: "rate_unit",
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled:
                                          !_vm.min_rate && !_vm.max_rate,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertProfileByManagement()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.country ||
                    _vm.managementAddedInfoMode.region ||
                    _vm.managementAddedInfoMode.city
                      ? _c(
                          "div",
                          [
                            _c(
                              "FormWrapper",
                              {
                                attrs: {
                                  title: "About resource",
                                  body: "Provide information about the resource",
                                  styleClass:
                                    "border-textTertiary border rounded-lg",
                                },
                              },
                              [
                                _c("ValidationObserver", [
                                  _c(
                                    "form",
                                    [
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "Country",
                                          rules: "required",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c(
                                                    "FormGroup",
                                                    {
                                                      attrs: {
                                                        title: "Country*",
                                                        errors: errors,
                                                      },
                                                      on: {
                                                        hasErrors: (
                                                          hasErrors
                                                        ) => {
                                                          _vm.countryHasErrors =
                                                            hasErrors
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "ProfileCountrySelect",
                                                        {
                                                          model: {
                                                            value: _vm.country,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.country = $$v
                                                            },
                                                            expression:
                                                              "country",
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          467221169
                                        ),
                                      }),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex w-full justify-between",
                                        },
                                        [
                                          _c("ValidationProvider", {
                                            staticClass: "mr-2 flex-1",
                                            attrs: { name: "State" },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function ({ errors }) {
                                                    return [
                                                      _c("RegionInput", {
                                                        attrs: {
                                                          countries:
                                                            _vm.country,
                                                          errors: errors,
                                                        },
                                                        model: {
                                                          value: _vm.state,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.state = $$v
                                                          },
                                                          expression: "state",
                                                        },
                                                      }),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              false,
                                              3875228843
                                            ),
                                          }),
                                          _c("FormGroup", {
                                            staticClass: "flex-1",
                                            attrs: {
                                              name: "postal_code",
                                              title: "Postal / Zip Code",
                                              placeholder:
                                                "Enter postal / zip code",
                                            },
                                            model: {
                                              value: _vm.postal_code,
                                              callback: function ($$v) {
                                                _vm.postal_code = $$v
                                              },
                                              expression: "postal_code",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("ValidationProvider", {
                                        attrs: {
                                          name: "City",
                                          rules: "name_with_specific_symbols",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function ({ errors }) {
                                                return [
                                                  _c("FormGroup", {
                                                    attrs: {
                                                      title: "City",
                                                      placeholder: "Enter city",
                                                      errors: errors,
                                                    },
                                                    on: {
                                                      hasErrors: (
                                                        hasErrors
                                                      ) => {
                                                        _vm.cityHasErrors =
                                                          hasErrors
                                                      },
                                                    },
                                                    model: {
                                                      value: _vm.city,
                                                      callback: function ($$v) {
                                                        _vm.city =
                                                          typeof $$v ===
                                                          "string"
                                                            ? $$v.trim()
                                                            : $$v
                                                      },
                                                      expression: "city",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          3093150553
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                ]),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex justify-end mt-2 pt-3 gap-2",
                                  },
                                  [
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Cancel",
                                        size: "lg",
                                        variant: "outline",
                                        processing: _vm.processing,
                                      },
                                      on: { click: _vm.closeModal },
                                    }),
                                    _c("UIButton", {
                                      attrs: {
                                        buttonText: "Save",
                                        size: "lg",
                                        variant: "black",
                                        processing: _vm.processing,
                                        disabled:
                                          !_vm.country.length ||
                                          (!_vm.state &&
                                            !_vm.postal_code &&
                                            !_vm.city) ||
                                          _vm.countryHasErrors ||
                                          _vm.cityHasErrors,
                                      },
                                      on: {
                                        click: () => {
                                          _vm.upsertProfileByManagement()
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm.managementAddedInfoMode.resume
                      ? _c("div", [_vm._v("Resume")])
                      : _vm._e(),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [_c("p", [_vm._v("Buttons")])]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }